import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';

function SunbitRaisedButton(props) {
  const {children, dataAt, ...restProps} = props;

  return (
    <Button data-at={dataAt} {...restProps} raised={true}>
      {children}
    </Button>
  );

}

SunbitRaisedButton.propTypes = {
  children: PropTypes.node,
  dataAt: PropTypes.string,
};

export default SunbitRaisedButton;




// WEBPACK FOOTER //
// ./src/components/common/material/RaisedButton.js